export function formatWellListForTextArea(wellList: string[]) {
  if (!wellList?.length) {
    return "";
  }

  return wellList?.map((well) => well)?.join("\n");
}
